import { DEFAULT_TABS, DEFAULT_LISTS, DEFAULT_ROUTES } from "@/lib/quickEnquiry";
const U = (id, w = 1200) => `https://images.unsplash.com/photo-${id}?auto=format&fit=crop&w=${w}&q=80`;
const pkg = (id, title, desc, price, img) => ({ id, title, desc, price, currency: "AED", per: "per person", image: U(img, 600), published: true });

export const SECTION_LABELS = {
  hero: "Hero", quick: "Quick Booking Enquiry", featured: "Featured Partner", packages: "Tour Packages",
  deals: "Exclusive Member Deals", why: "Why Join", custom: "Custom Holiday Plan", partner: "Become a Partner",
};

// Field holding each section's visible heading (edited via the CMS "Section title" box)
export const SECTION_TITLE_KEYS = { hero: "headline1", quick: "title", featured: "badge", packages: "title",
  deals: "title", why: "title", custom: "title", partner: "title" };

export const LANDING_DEFAULTS = {
  order: ["hero", "quick", "featured", "packages", "deals", "why", "custom", "partner"],
  hidden: {},
  header: {
    menu: [
      { label: "Home", url: "#top" }, { label: "Tour Packages", url: "#packages" },
      { label: "Partner Offers", url: "#deals" }, { label: "About", url: "#why" },
    ],
    login: { label: "Login", url: "/login/customer" },
    join: { label: "Join Now", url: "/join" },
  },
  hero: {
    tagline: "Your Journey. More Rewards.", headline1: "Travel More,", headline2: "Get More.",
    subtext: "Exclusive member benefits, partner offers and curated travel experiences — all in one place.",
    image: U("1724966773791-5935c2b5b886", 2000),
    chips: [{ icon: "gift", label: "Member Offers" }, { icon: "plane", label: "Travel Deals" }, { icon: "star", label: "Exclusive Experiences" }],
  },
  quick: {
    title: "Quick Booking Enquiry", subtitle: "Tell us your travel plans and we'll get back to you with the best options.",
    button: "WhatsApp Enquiry",
    tabs: DEFAULT_TABS, lists: DEFAULT_LISTS, routes: DEFAULT_ROUTES, contact: { enabled: true },
  },
  featured: {
    badge: "Featured Partner of the Month", title: "Atlantis The Palm",
    subtitle: "Luxury Stay • World-Class Dining • Unforgettable Experiences",
    image: U("1700728889355-577d2619be82", 1800), seal: "Special Member Rates",
    memberCta: "Claim Offer", guestCta: "Join to Unlock Member Rates",
  },
  packages: {
    title: "Zola Tour Packages", subtitle: "Explore handpicked holiday packages for unforgettable experiences.",
    viewAll: { label: "View All", url: "#packages" }, button: "Enquire Now",
    items: [
      pkg("dubai", "Dubai Discovery", "3 nights, 4 days package with city tour and desert safari.", 2999, "1512453979798-5ea266f8880c"),
      pkg("maldives", "Maldives Getaway", "5 nights, 6 days in a luxury beach resort.", 4999, "1514282401047-d79a71a590e8"),
      pkg("europe", "Europe Highlights", "7 nights, 8 days covering Paris, Rome & Florence.", 6999, "1502602898657-3e91760cbb34"),
      pkg("swiss", "Switzerland Adventure", "5 nights, 6 days with scenic train journeys.", 5499, "1533326150585-8692556a5f04"),
      pkg("bali", "Bali Escape", "4 nights, 5 days with cultural tours and beach time.", 2499, "1573790387438-4da905039392"),
      pkg("istanbul", "Istanbul Experience", "5 nights, 6 days with guided city tours.", 3499, "1466442929976-97f336a657be"),
    ],
  },
  deals: {
    title: "Exclusive Member Deals", subtitle: "Special offers from our trusted partners. Show your membership and save more.",
    categories: ["Restaurants", "Hotels", "Cars", "Yachts", "Attractions"],
  },
  why: {
    title: "Why Join Zola Rewards?", subtitle: "More than just a membership. It's your gateway to exclusive travel benefits.",
    image: U("1761047726498-67eeb8b35d7c", 1000), script: "Your Next Adventure Awaits",
    items: [
      { icon: "heart", title: "Exclusive Partner Offers", text: "Save on top brands and experiences" },
      { icon: "gift", title: "Earn Rewards", text: "Get rewarded for your travels" },
      { icon: "star", title: "Curated Experiences", text: "Handpicked for our members" },
      { icon: "support", title: "Dedicated Support", text: "We're here to help, wherever you are" },
    ],
  },
  custom: {
    eyebrow: "Plan your next holiday", title: "Request a Custom Holiday Plan",
    text: "Tell us your destination, travel dates, number of travellers and budget. Our team will create a personalized plan just for you.",
    image: U("1602002418816-5c0aeef426aa", 900), button: { label: "Enquire Now", url: "whatsapp" },
    bullets: ["Destination", "Travel Dates", "Number of Travellers", "Budget Range"],
  },
  partner: {
    title: "Become a Zola Partner", text: "Reach a wider audience and grow your business with Zola Rewards.",
    subtext: "Partner with us and get featured on our platform.", image: U("1672380135241-c024f7fbfa13", 700),
    button: { label: "Partner With Us", url: "whatsapp" }, chips: ["Restaurants", "Hotels", "Attractions", "Yachts", "Cars"],
  },
  footer: {
    company: "Zola Safari Tours FZE",
    links: [{ label: "Home", url: "#top" }, { label: "Tour Packages", url: "#packages" }, { label: "Partner Offers", url: "#deals" },
            { label: "About", url: "#why" }, { label: "Contact", url: "mailto:enquiry@zolasafari.com" }],
    socials: [{ icon: "instagram", url: "https://instagram.com" }, { icon: "facebook", url: "https://facebook.com" },
              { icon: "whatsapp", url: "whatsapp" }, { icon: "youtube", url: "https://youtube.com" }],
    addresses: ["Sharjah: Block B-B29-155, SRTIP, Sharjah, UAE · +971 52 718 4369",
                "Kochi: Office 111, 1st Floor, HI-LITE Platino, Shankar Nagar Colony Road, Chembakkara – Kannadikkadu, Maradu, Kochi – 682304, Kerala, India · +91 89216 53417"],
    copyright: "© 2025 Zola Safari Tours FZE. All rights reserved.",
    terms: { label: "Terms & Conditions", url: "#" }, privacy: { label: "Privacy Policy", url: "#" },
  },
};

export const PORTAL_DEFAULTS = {
  order: ["deals", "quick", "packages", "featured", "why", "custom", "partner", "hero"],
  sections: {
    hero: { show: false, mode: "icon", icon: "star", label: "Welcome" },
    quick: { show: true, mode: "expanded", icon: "plane", label: "Booking" },
    featured: { show: true, mode: "icon", icon: "star", label: "Featured" },
    packages: { show: true, mode: "icon", icon: "pin", label: "Packages" },
    deals: { show: true, mode: "expanded", icon: "gift", label: "Deals" },
    why: { show: true, mode: "icon", icon: "heart", label: "Why Join" },
    custom: { show: true, mode: "icon", icon: "calendar", label: "Custom Plan" },
    partner: { show: true, mode: "icon", icon: "handshake", label: "Partner" },
  },
};

export function mergeLanding(saved) {
  const out = {};
  for (const [k, v] of Object.entries(LANDING_DEFAULTS)) {
    const s = saved?.[k];
    out[k] = s && typeof v === "object" && !Array.isArray(v) ? { ...v, ...s } : s ?? v;
  }
  out.order = [...new Set([...(saved?.order || []), ...LANDING_DEFAULTS.order])].filter((id) => SECTION_LABELS[id]);
  const sp = saved?.portal || {};
  out.portal = {
    order: [...new Set([...(sp.order || []), ...PORTAL_DEFAULTS.order])].filter((id) => SECTION_LABELS[id]),
    sections: Object.fromEntries(Object.entries(PORTAL_DEFAULTS.sections).map(([id, d]) => [id, { ...d, ...(sp.sections?.[id] || {}) }])),
  };
  return out;
}

export const safeUrl = (u) => (/^(https?:\/\/|\/|#|mailto:|tel:)/i.test(u || "") ? u : "#");
